import TableWithContainerStyles from './TableWithContainer.Styles.js';
import React from 'react';
import { Grid } from "@material-ui/core";
import DefaultTable from "utils/Table/DefaultTable";
import PaginatedTable from "utils/Table/PaginatedTable";
import ExportButton from "utils/CustomButtons/ExportToCVSButton";

const merge = (target, source, mutable = false) => {
    const newObj = typeof target == 'object' ? (mutable ? target : Object.assign({}, target)) : {};
    for (const prop in source) {
        if (target[prop] == null || typeof target[prop] === 'undefined') {
            newObj[prop] = source[prop];
        } else if (Array.isArray(target[prop])) {
            newObj[prop] = source[prop] || target[prop];
        } else if (target[prop] instanceof RegExp) {
            newObj[prop] = source[prop] || target[prop];
        } else {
            newObj[prop] = typeof source[prop] === 'object' ? merge(target[prop], source[prop]) : source[prop];
        }
    }
    return newObj;
};

export default function TableWithContainer(props) {
    const style = props.style ? merge(TableWithContainerStyles(), props.style) : TableWithContainerStyles();
    
    return (
        <Grid container style={style.Grid}>
            <Grid item style={style.Grid.Item}>
                {props.title && <div style={style.Title}>{props.title}</div>}
                {props.subtitle && <div style={style.Subtitle}>{props.subtitle}</div>}
                {props.rowsPerPage ? (
                    <PaginatedTable
                        style={style.Table}
                        loading={props.loading}
                        fixedColumns={props.fixedColumns}
                        headers={props.headers}
                        rows={props.rows}
                        footers={props.footers}
                        rowsPerPage={props.rowsPerPage}
                    />
                ) : (
                    <DefaultTable
                        style={style.Table}
                        loading={props.loading}
                        fixedColumns={props.fixedColumns}
                        headers={props.headers}
                        rows={props.rows}
                        footers={props.footers}
                    />
                )}
                {props.exportName && <ExportButton ExportName={props.exportName} />}
            </Grid>
        </Grid>
    );
};
